import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Spin, Result, Button } from 'antd';
import { joinWaitingRoom } from '../../api/waitingroom';
import { isInWaitingRoom, getWaitingRoomCache } from '../../utils/waitingRoomCache';

const QrJoinTrigger: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | undefined>(undefined);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if already in waiting room
    if (isInWaitingRoom()) {
      const cached = getWaitingRoomCache();
      setError(`Ya estás en la sala de espera con el código ${cached?.code}`);
      setLoading(false);
      return;
    }

    // Llamamos sin parámetros para que use el token de localStorage
    joinWaitingRoom()
      .then(() => {
        navigate('/waiting-room/confirmation', { replace: true });
      })
      .catch(err => {
        setError(err instanceof Error ? err.message : String(err));
        setLoading(false);
      });
  }, [navigate]);

  if (loading && !error) {
    return (
      <Card style={{ 
        textAlign: 'center', 
        margin: '1rem',
        marginTop: '2rem',
        padding: '1rem'
      }}>
        <Spin size="large" tip="Uniéndote a la sala de espera..." />
      </Card>
    );
  }

  if (error) {
    return (
      <Result
        status="error"
        title="No se pudo unir a la sala de espera"
        subTitle={error}
        extra={[
          <Button key="home" type="primary" onClick={() => navigate('/')}>
            Ir al Inicio
          </Button>,
          <Button key="retry" onClick={() => window.location.reload()}>
            Reintentar
          </Button>
        ]}
      />
    );
  }

  return null;
};

export default QrJoinTrigger;
